module.exports = __webpack_public_path__ + "static/img/logo.54a4c711.svg";